import {Component, OnDestroy, OnInit, viewChild, output, inject, DestroyRef, ChangeDetectionStrategy} from "@angular/core"
import {RoutedDialogComponent} from "@common/components/dialogs/routed-dialog/routed-dialog.component"
import {DialogSize} from "@common/models/dialogs"
import {HotkeyLayerId, Hotkeys} from "@common/services/hotkeys/hotkeys.service"
import {PictureViewerComponent} from "@platform/components/pictures/picture-viewer/picture-viewer.component"
import {Location} from "@angular/common"
import {ActionBarComponent} from "@common/components/menu/actions/action-bar/action-bar.component"
import {ActionItemComponent} from "@common/components/menu/actions/action-item/action-item.component"
import {takeUntilDestroyed} from "@angular/core/rxjs-interop"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-picture-viewer-dialog",
    templateUrl: "./picture-viewer-dialog.component.html",
    styleUrls: ["./picture-viewer-dialog.component.scss"],
    imports: [ActionBarComponent, RoutedDialogComponent, ActionItemComponent, PictureViewerComponent],
})
export class PictureViewerDialogComponent implements OnInit, OnDestroy {
    readonly $overlayDialog = viewChild.required<RoutedDialogComponent>("overlayDialog")
    readonly close = output<void>()
    dialogSizes = DialogSize

    private readonly hotkeyLayerId: HotkeyLayerId
    private readonly location = inject(Location)
    private readonly destroyRef = inject(DestroyRef)
    private readonly hotkeys = inject(Hotkeys)

    constructor() {
        // register this.hotkeys
        this.hotkeyLayerId = this.hotkeys.createLayer() // create a layer since this is a modal dialog
        this.hotkeys
            .addShortcut("Escape")
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => this.overlayClosed())
    }

    ngOnInit(): void {}

    async closeOverlay() {
        await this.$overlayDialog().closeIfClean()
    }

    overlayClosed(): void {
        this.close.emit()
    }

    ngOnDestroy() {
        this.hotkeys.removeLayer(this.hotkeyLayerId)
    }
}
